<script setup>
import TableCell from "@/components/global-themed/table/TableCell.vue";
import TableRow from "@/components/global-themed/table/TableRow.vue";
import DomainAuthorityTag from "@/components/competition/partials/backlinks/AuthorityTag.vue";
import useDates from "@/composables/useDates";
import {computed} from "vue";
import {useStore} from "vuex";

const props = defineProps({
  backlink: {
    type: Object,
    required: true,
  },
});

const store = useStore();

const dates = useDates();
const mode = computed(() => store.getters['backlinks/mode']);
const activeTab = computed(() => store.getters['backlinks/activeTab']);
const url = computed(() => props.backlink.targetUrl ? new URL(props.backlink.targetUrl) : '');
const advancedMode = computed(() => mode.value === 'advanced');
</script>

<template>
  <TableRow :class="advancedMode ? 'tw-grid-cols-21' : 'tw-grid-cols-16'">
    <TableCell
      v-if="!advancedMode"
      col-span="4"
    >
      <span class="tw-truncate tw-w-auto tw-block">{{ backlink.domain }}</span>
    </TableCell>
    <TableCell :col-span="advancedMode ? 5 : 6">
      <div
        v-if="advancedMode"
      >
        {{ backlink.domain }}
      </div>
      <a
        :href="backlink.url"
        :title="backlink.url"
        target="_blank"
        class="tw-text-blue tw-underline tw-truncate tw-w-auto tw-block"
      >
        {{ backlink.relativeUrl }}
      </a>
    </TableCell>
    <TableCell
      class="tw-flex tw-justify-center"
      :col-span="2"
    >
      <div
        v-if="backlink.manual"
        v-tooltip="{
          content: 'This backlink was added manually',
          placement: 'bottom',
          theme: 'dark-blue-tooltip',
        }"
        class="tw-rounded-xl tw-w-10 tw-h-10 tw-flex tw-items-center tw-justify-center tw-py-1 tw-font-semibold tw-text-lg tw-cursor-pointer tw-bg-everest tw-text-everest-highlight"
      >
        <SvgVue icon="icons/minus" />
      </div>
      <DomainAuthorityTag
        v-else
        :value="backlink.domainAuthority"
      />
    </TableCell>
    <TableCell
      class="tw-flex tw-justify-center"
      :col-span="2"
    >
      <div
        v-if="backlink.manual"
        v-tooltip="{
          content: 'This backlink was added manually',
          placement: 'bottom',
          theme: 'dark-blue-tooltip',
        }"
        class="tw-rounded-xl tw-w-10 tw-h-10 tw-flex tw-items-center tw-justify-center tw-py-1 tw-font-semibold tw-text-lg tw-cursor-pointer tw-bg-everest tw-text-everest-highlight"
      >
        <SvgVue icon="icons/minus" />
      </div>
      <DomainAuthorityTag
        v-else
        :value="backlink.pageAuthority"
      />
    </TableCell>
    <TableCell
      class="tw-flex tw-justify-center"
      :col-span="advancedMode ? 3 : 2"
    >
      <template v-if="activeTab === 'lost'">
        {{ dates.formattedDate(backlink.lost) }}
      </template>
      <template v-else>
        {{ dates.formattedDate(backlink.found) }}
      </template>
    </TableCell>
    <TableCell
      v-if="advancedMode"
      class="tw-flex tw-justify-center"
      :col-span="advancedMode ? 2 : 1"
    >
      <span v-if="backlink.manual" />
      <span v-else>
        {{ backlink.noFollow ? 'Nofollow' : 'Follow' }}
      </span>
    </TableCell>
    <TableCell
      v-if="advancedMode"
      col-span="5"
    >
      <div
        class="tw-max-w-full tw-truncate"
        :title="backlink.anchorText"
      >
        <span v-if="backlink.manual" />
        <span v-else>
          {{ backlink.anchorText }}
        </span>
      </div>

      <a
        v-if="!backlink.manual"
        :href="backlink.targetUrl"
        target="_blank"
        class="tw-text-blue tw-underline tw-truncate tw-block"
      >
        <span
          v-tooltip="{
            content: backlink.targetUrl,
            placement: 'bottom',
            theme: 'dark-blue-tooltip',
          }"
        >{{ url?.pathname ?? '' }}</span>
      </a>
    </TableCell>
    <TableCell
      v-if="advancedMode"
      class="tw-flex tw-justify-center"
      col-span="2"
    >
      <span v-if="backlink.manual" />
      <span v-else>
        {{ backlink.linkType }}
      </span>
    </TableCell>
  </TableRow>
</template>
